import { ExclamationCircleFilled } from '@ant-design/icons'
import { Tag } from 'antd'
import { FC } from 'react'

const MaterialInCuttingIndicator: FC = () => {
    return (
        <Tag key='material-in-cutting-indicator' color='warning' icon={<ExclamationCircleFilled/>}>
            Раскрой
        </Tag>
    )
}

export default MaterialInCuttingIndicator
